import { InterweaveExtContext } from './interweave-ext/interweave-ext';
import Cave from './cave/cave';

export function UIBasePlugin(context: InterweaveExtContext) {
  context.interweaveFactory.register('cave', Cave);
}
